export default {
    i_got_it: 'ខ្ញុំយល់',
    save: 'រក្សាទុក',
    save_changes: 'ប្ដូរការរក្សាទុក',
    cancel: 'បោះបង់',
    go_back: 'វិលវិញ',
    manage: 'គ្រប់គ្រង',
    add_new_record: 'ថែមកំណត់ត្រាថ្មី។',
    add_forwarder: 'ថែមអ្នកបញ្ជូនបន្ត',
    add_catch_all: 'ថែមការទួលយកទាំងអស់',
    add_redirect: 'ថែមការប្ដូរទិល',
    add_wildcard_redirect: 'ថែមកាតតំណាងការប្ដូរទិល',
    edit_mode: 'ម៉ូដកែសម្រួល',
    select_country: '--ជ្រើសរើសប្រទេស--',
    select_province: '-- ជ្រើសរើសរដ្ឋ/ខេត្ --',
    extend: 'ពង្រីក',
    reactivate: 'ដំណើរការឡើងវិញ',
    select_duration: '--ជ្រើសរើសរយៈពេល--',
    top_up: 'ទឹកប្រាក់បន្ថែម',
    withdraw: 'ដកលុយ',
    confirm: 'បញ្ជាក់',
    back: 'បកក្រោយ',
    next: 'ទៅមុខ',
    skip: 'រំលង',
    remove: 'ដកចេញ',
    show_more: 'បង្ហាញបន្ថែម',
    show_less: 'បង្ហាញតិច',
    register_now: 'ចុះឈ្មោះភ្លាម',
    download_template: 'ទាញយកគំរូ',
    send: 'ផ្ញើ',
    resend: 'ផ្ញើឡើងវិញ',
    ok: 'យល់ព្រម',
    new_template: 'គំរូថ្មី',
    select_template: 'ជ្រើសរើសគំរូ',
    add: 'បន្ថែម',
    export_report: 'របាយការណ៍នាំចេញ',
    download: 'ទាញយក',
    view_all: 'មើលទាំងអស់។',
    edit: 'កែសម្រួល',
    change_now: 'ផ្លាស់ប្តូរឥឡូវនេះ',
    change_domain: 'ផ្លាស់ប្តូរ domain',
    verify: 'ផ្ទៀងផ្ទាត់',
    add_new_cloud_server: 'បន្ថែម Cloud Serverថ្មី',
    add_new_cloud_hosting: 'បន្ថែម Cloud Hostingថ្មី',
    add_new_shared_hosting: 'បន្ថែម Shared Hostingថ្មី',
    add_new: ' បន្ថែម​ថ្មី',
    upgrade: 'តំឡើង',
    delete: 'លុប',
    save_all_changes: 'រក្សាទុកការផ្លាស់ប្តូរទាំងអស់។',
    view_failed_list: 'បញ្ជីបរាជ័យ',
    pay_now: 'បង់លុយឥឡូវនេះ',
    apply: 'អនុវតិ្ត',
    view_detail: 'មើលព័ត៌មានលម្អិត',
    download_receipt: 'ទាញយកបង្កាន់ដៃ',
    download_invoice: 'ទាញយកវិក្កយបត្រ',
    download_top_up: 'ទាញយកការបញ្ចូលទឹកប្រាក់',
    download_vat_invoice: 'ទាញយកវិក្កយបត្រ VAT',
    invoice: 'វិក្ក័យប័ត្រ',
    invoices: 'វិក្ក័យប័ត្រ',
    receipt: 'បង្កាន់ដៃ',
    vat_invoice: 'វិក្កយបត្រ VAT',
    login: 'ចូល',
    enable: 'បើក',
    disable: 'ការបិទ',
    close: 'បិទ',
    loading_processing: 'ដំណើរការទិន្នន័យ',
    wp_admin: 'អ្នកគ្រប់គ្រង WP',
    upgrade_now: 'Upgrade ឥឡូវ​នេះ',
    change: 'ផ្លាស់ប្តូរ',
    backup_installation: 'ការដំឡើងបម្រុងទុក',
    activate: 'ធ្វើឱ្យសកម្ម',
    install: 'ដំឡើង',
    installed: 'បានដំឡើង',
    installing: 'ការដំឡើង',
    restore_installation: 'ដំឡើងឡើងវិញ',
    upload: 'ផ្ទុកឡើង',
    restore: 'ស្ដារឡើងវិញ',
    reinstall: 'ដំឡើងឡើងវិញ',
    revoke: 'ដកហូត',
    copy: 'ចម្លង',
    access_file: 'ចូលប្រើឯកសារ',
    access_db: 'ចូលប្រើមូលដ្ឋានទិន្នន័យ',
    click_here: 'សូមចុចត្រង់នេះ',
    see_more: 'បញ្ហាញបន្ថែម',
    confirm_payment: 'បញ្ជាក់ការទូទាត់',
    back_to_invoices: 'ត្រឡប់ទៅវិក្កយបត្រវិញ',
    done_transfer: 'ការផ្ទេររួចរាល់',
    update_information: 'ធ្វើបច្ចុប្បន្នភាពព័ត៌មាន',
    yes: 'បាទ/ចាស',
    no: 'ទេ',
    no_later: 'ទេ, ចាំពេលក្រោយ',
    buy_domains: 'ទិញដែន',
    reissue: 'ចេញសារជាថ្មី',
    active: 'សកម្ម',
    read_more: 'អាន​បន្ថែម',
    submit: 'ដាក់ស្នើ',
    got_it: 'យល់ហើយ',
    edit_method: 'វិធីសាស្រ្តកែសម្រួល',
    get_record: 'ទទួលបានកំណត់ត្រា',
    resend_mail: 'ផ្ញើសំបុត្រឡើងវិញ',
    download_file: 'ទាញ​យក​ឯកសារ',
    decode: 'ឌិកូដ',
    done: 'រួចរាល់',
    change_email: 'ផ្លាស់ប្តូរអ៊ីមែល',
    see_history: 'មើលប្រវត្តិ',
    detail: 'លម្អិត',
    create_new: 'បង្កើតថ្មី',
    enable_backup: 'បើកដំណើរការបម្រុងទុក',
    disable_backup: 'បិទដំណើរការបម្រុងទុក',
    change_os: 'ផ្លាស់ប្តូរ/ដំឡើង OS ឡើងវិញ',
    restoring: 'ការស្ដារឡើងវិញ',
    try_demo: 'សាកល្បងប្រើប្រាស់',
    here: 'នៅទីនេះ',
    search: 'ស្វែងរក',
    credit_note: 'Credit Note',
    download_credit_note: 'Download Credit Note',
    print: 'បោះពុម្ព',
    expand_all: 'ពង្រីកទាំងអស់',
    collapse_all: 'បង្រួមទាំងអស់',
    continue_with_google: 'បន្តជាមួយ Google',
    continue: 'បន្ត',
    try_again: 'ព្យាយាមម្តងទៀត',
    contracts: 'កិច្ចសន្យា',
    contract: 'កិច្ចសន្យា',
    download_contract: 'ទាញយកកិច្ចសន្យា',
    accept_and_confirm: 'យល់ព្រម និង បញ្ជាក់',
    upgrade_package: 'ដំឡើងកំណែកញ្ចប់',
    extend_storage: 'ពង្រីកការផ្ទុក',
    renew_service: 'បន្តសេវាកម្ម',
};
